export const JOB_APPLICATION_TOOLTIP = 'jobs-onboarding-application-tooltip';
export const JOB_APPLICATION_LOCAL_STORAGE_KEY = 'jobs-onboarding-application-local-storage-key';
